export const ExportToImage = async (
  elementIds: string[],
  fileName: string = 'exported-image',
  excludeElementId: string | null = null
) => {
  try {
    const response = await fetch('http://localhost:3001/export', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        url: window.location.href, // URL of the current page
        elementIds,
        excludeElementId,
        fileName,
      }),
    });

    if (response.ok) {
      console.log('Export successful');
    } else {
      console.error('Failed to export:', await response.text());
    }
  } catch (error) {
    console.error('Error calling export API:', error);
  }
};
